import {BookingsHttp} from "../../../http/bookings";

export default {
    /**
     *
     * @param commit
     * @param query <string, boolean>
     * @returns {Promise<void>}
     */
    async setBookings({commit}, query) {
        const bookings = await BookingsHttp.fetchBookings(query.day, query.isWeek).then(result => result.data);
        commit('setBookings', bookings);
    },
    setActiveBooking({commit}, booking) {
        commit('setActiveBooking', booking);
    },
    setManageBookingDialog({commit}, status) {
        commit('setManageBookingDialog', status);
    },
    setDeleteBookingDialog({commit}, status) {
        commit('setDeleteBookingDialog', status);
    },
    resetActiveBooking({commit}) {
        commit('resetActiveBooking');
    }
}
